export default __webpack_public_path__ + "457a5ebcae3429e9a1cc42fb5e1dd502.svg";